import { render, staticRenderFns } from "./BetstopCheckModal.vue?vue&type=template&id=4679f6b3&"
import script from "./BetstopCheckModal.vue?vue&type=script&lang=js&"
export * from "./BetstopCheckModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports